import React, { FC, useEffect, useState } from 'react';
import { useField } from 'formik';
import COSelectSearch from 'shared/components/COSelectSearch';
import RequestProductionRegionModal from 'shared/components/RequestProductionRegion';
import { ReactComponent as Add } from 'assets/icons/add.svg';
import styles from './bestFitRegion.module.scss';
import DashboardService from 'services/DashboardService/dashboard.service';
import Stage1AndStage2ProductService from 'services/ProductsService/stage1AndStage2Product.service';

interface BestFitRegionProps {
  name: string;
  label: string;
  placeholder: string;
  onChange?: (value: string) => void;
  dropdownRender?: (menu: React.ReactElement) => React.ReactElement;
  disabled: boolean;
  onFocus?: () => void;
  errorMessageStyle: string;
  ingridientFieldName: string;
  isIngredientId?: boolean;
}

const BestFitRegion: FC<BestFitRegionProps> = props => {
  const {
    name,
    label,
    placeholder,
    onChange,
    disabled,
    onFocus,
    ingridientFieldName,
    isIngredientId,
  } = props;

  const [field] = useField(ingridientFieldName);

  const { bestFitRegion, fetchIngredientOrigin, resetBestFitRegion } =
    Stage1AndStage2ProductService();
  const { fetchActivityMapping, activityMapping } = DashboardService();

  const [showBestFitRegionModal, setShowBestFitRegionModal] =
    useState<boolean>(false);

  const toggleBestFitRegion = () => {
    setShowBestFitRegionModal((prevState: boolean) => !showBestFitRegionModal);
  };

  useEffect(() => {
    if (!field.value) {
      resetBestFitRegion();
      return;
    }
    fetchActivityMapping({
      activity_label: field.value,
    });
    fetchIngredientOrigin({
      activity_label: field.value,
    });
  }, [field.value]);

  const ingredientId: string =
    activityMapping?.length > 0 ? activityMapping[0]?.id?.toString() ?? '' : '';

  return (
    <>
      {showBestFitRegionModal && (
        <RequestProductionRegionModal
          showModalState={showBestFitRegionModal}
          handleModalCancel={toggleBestFitRegion}
          handleModalConfirm={toggleBestFitRegion}
          ingredientName={field.value}
          isIngredientId={isIngredientId}
          ingredientId={ingredientId}
        />
      )}

      <COSelectSearch
        name={name}
        label={label}
        placeholderstring={placeholder}
        onChange={onChange}
        options={bestFitRegion}
        disabled={disabled}
        onFocus={onFocus}
        dropdownRender={(menu:React.ReactElement) => {
          return (
            <>
              {bestFitRegion?.length > 0 && (
                <div
                  className={styles.dropdownCreateButton}
                  onClick={toggleBestFitRegion}>
                  <div className={styles.requestText}>
                    <Add /> Request production region
                  </div>
                </div>
              )}
              {menu}
            </>
          );
        }}
      />
    </>
  );
};

export default BestFitRegion;
